import { render, staticRenderFns } from "./CInfoBlockList.vue?vue&type=template&id=a942172a&scoped=true&"
import script from "./CInfoBlockList.vue?vue&type=script&lang=ts&"
export * from "./CInfoBlockList.vue?vue&type=script&lang=ts&"
import style0 from "./CInfoBlockList.vue?vue&type=style&index=0&id=a942172a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a942172a",
  null
  
)

export default component.exports